const all = [
    {
        name: 'Elegant Converter',
        slug: 'elegantconverter',
        keywords: ['macos', 'menubar', 'tech', 'app', 'swift', 'converter', 'video', 'formats', 'images', 'clips', 'mov', 'mp4', 'mp3', 'gif'],
        header: {
            background: '#DCD728',
            twitter: 'ElegantConvert'
        },
        headline: {
            title: 'Elegant video converter for the Mac',
            text: 'Elegant Converter is a native macOS app that helps quickly convert multiple audio and videos files to many formats. \n\nThe app is written in native and provides fast experience and slick looking. You can drag and drop files to the left panel, select output formats in the centre panel and can. choose to convert one or many files at the same time. In the right panel you can view converting progress and status.',
            imageUrl: 'https://user-images.githubusercontent.com/2284279/99626909-818afb80-2a33-11eb-9e00-8dabef51cc35.png'
        },
        productHunt: {
            link: 'https://www.producthunt.com/posts/elegant-converter',
            id: '170037'
        },
        download: {
            appstore: [
                {
                    platform: "macOS",
                    version: "10.15",
                    id: 'id1479676588' 
                }
            ]
        },
        features: [
            {
                title: 'A wide range of formats',
                texts: [
                    'Support many audio and video formats: mkv, mov, mp4, mp3, gif, ogg, wav, opus, avi, webm, flac, ...',
                    'Show detailed information about audio and video streams within a file, including duration, start time, bit rate, sample rate, frame rate, aspect ratio, codec and more informations',
                    'Built in Swift natively for the Mac'
                ],
                imageUrl: 'https://user-images.githubusercontent.com/2284279/99353101-2676ce80-28a4-11eb-9e1f-e09e34f7812b.png',
                shadow: true
            },
            {
                title: 'Convert multiple files',
                texts: [
                    'Convert one or all files at once',
                    'Detail conversion status reporting',
                    'Conveniently drag and drop multiple files',
                    'Lots of tasks to choose from',
                    'Special conversion to and from gif file',
                    'Compress to reduce file sizes for audio, video, gif',
                    'Resize images'
                ],
                imageUrl: 'https://user-images.githubusercontent.com/2284279/99353103-28409200-28a4-11eb-88a1-9047b47b16e6.png',
                shadow: true
            },
            {
                title: 'Light and dark mode',
                texts: [
                    'Support beautiful light and dark themes'
                ],
                imageUrl: 'https://user-images.githubusercontent.com/2284279/99353106-2971bf00-28a4-11eb-9919-810b956e023d.png',
                shadow: true
            },
            {
                title: 'Lots of settings',
                texts: [
                    'There are many options to adjust the converted files',
                    'Specify duration: crop media files',
                    'Change video frame rate: adjust fps of video stream',
                    'Change resolution: adjust resolution of each frame inside video',
                    'Change aspect ratio: adjust aspect ratio to your liking, say 1:1, 16:9 or 4:3',
                    'Remove audio stream or video stream from media files',
                    'Change bit rate: change bit rate of audio stream to reduce file sizes.'
                ],
                imageUrl: 'https://user-images.githubusercontent.com/2284279/99353126-3393bd80-28a4-11eb-95a7-8204ddf17785.png',
                shadow: true
            }
        ],
        showcase: {
            platforms: ['macOS'],
            background: '#E7E5F5',
            tagline: 'Convert audio and video to different formats',
            detail: true
        }
    },
    {
        name: 'Almighty',
        slug: 'almighty',
        productHunt: {
            link: 'https://www.producthunt.com/posts/almighty',
            id: '155506'
        },
        download: {
            gumroad: {
                id: "lbZCs"
            }
        },
        showcase: {
            tagline: 'Powerful configuration for your mac',
            platforms: ['macOS'],
            background: '#F4BB56'
        }
    },
    {
        name: 'Alias',
        slug: 'alias',
        keywords: ['macos', 'menubar', 'tech', 'app', 'swift', 'native', 'shortcut', 'manager', 'best', 'launch', 'file', 'folder', 'quick'],
        headline: {
            title: 'Powerful shortcut launchpad for Mac',
            text: 'Alias is a native menu bar macOS application that allows us to easily manage shortcut for links, file, folder and app',
            image: 'banner.png',
        },
        header: {
            background: '#DF8583'
        },
        productHunt: {
            link: 'https://www.producthunt.com/posts/alias-3',
            id: '190732'
        },
        download: {
            appstore: [
                {
                    id: 'id1504336758',
                    platform: "macOS",
                    version: "10.15"
                }
            ]
        },
        features: [
            {
                title: 'Conveniently',
                texts: [
                    'Easily accessible right from the menu bar',
                    'Dark and light mode support',
                    'Click + to group shortcut items by page'
                ],
                image: 'group.png',
                titleIcon: 'laptop_mac',
                shadow: true
            },
            {
                title: 'Just drag any app and file here',
                texts: [
                    'Drag any file, app, folder you want to manage and execute later',
                    'Right click for more menu. There you can change order, edit name.',
                    'Menu is also accessible via menu icon on the bottom right near the gear icon'
                ],
                image: 'drag.png',
                titleIcon: 'eco',
                shadow: true
            },
            {
                title: 'View, filter and search',
                texts: [
                    'Filter by date added and name',
                    'Show as grid or list',
                    'Search for all shortcut items that you have added'
                ],
                image: 'search.png',
                titleIcon: 'image_search',
                shadow: true
            }
        ],
        showcase: {
            platforms: ['macOS'],
            background: '#EE7F80',
            tagline: 'Save and manage shortcuts in your macOS menubar',
            detail: true
        }
    },
    {
        name: 'Quick Check',
        slug: 'quickcheck',
        keywords: ['macos', 'menubar', 'tech', 'app', 'todo', 'check', 'quick', 'tag', 'priority', 'free', 'trial', 'download', 'features', 'screenshots', 'native', 'swift'],
        header: {
            background: '#A8DAC0'
        },
        headline: {
            title: 'Your next favorite todo manager',
            text: 'Quick Check is a native macOS menu bar application that allows you to easily manage your todo items.',
            image: 'banner.png',
        },
        productHunt: {
            link: 'https://www.producthunt.com/posts/quick-check',
            id: '191723'
        },
        download: {
            appstore: [
                {
                    id: 'id1505838529',
                    platform: 'macOS',
                    version: "10.15"
                }
            ]
        },
        features: [
            {
                title: 'Conveniently',
                texts: [
                    'Conveniently accessible from your menu bar',
                    'Support light and dark mode',
                    'Built in Swift natively for the Mac',
                    'View detail by hovering and press view icon. There you can view dates and add notes'
                ],
                image: 'detail.png',
                titleIcon: 'laptop_mac',
                shadow: true
            },
            {
                title: 'Create and check',
                texts: [
                    'Easily add new to do by typing and press enter',
                    'Mark items as todo and done. You can filter for all items, just todo items or done items',
                    'Search for all todo and done items',
                ],
                image: 'search.png',
                titleIcon: 'calendar_today',
                shadow: true
            },
            {
                title: 'Take notes easily',
                texts: [
                    'Make a new note. You can update title, text and tags',
                    'In advanced search for note you can search for title, text and tags',
                    'Tag a todo item with color for easily recognising'
                ],
                image: 'check.png',
                titleIcon: 'notes',
                shadow: true
            }
        ],
        showcase: {
            platforms: ['macOS'],
            background: '#A8DAC0',
            tagline: 'Slick to do manager for your mac',
            detail: true
        }
    },
    {
        name: 'Frame Recorder',
        slug: 'framerecorder',
        productHunt: {
            link: 'https://www.producthunt.com/posts/frame-recorder',
            id: '167434'
        },
        download: {
            appstore: [
                {
                    platform: "macOS",
                    version: "10.14",
                    id: "id1479465103"
                }
            ]
        },
        showcase: {
            platforms: ['macOS'],
            background: '#F09837',
            tagline: 'Record gif and video with device frame',
        }
    },
    {
        name: 'Learn Talks',
        slug: 'learntalks',
        web: {
            link: 'https://learntalks.com'
        },
        showcase: {
            tagline: 'Awesome conference and meetup talks',
            platforms: ['Web'],
            background: '#F1F7E2'
        }
    },
    {
        name: 'WWDC Together',
        slug: 'wwdctogether',
        web: {
            link: 'https://wwdctogether.com'
        },
        showcase: {
            tagline: 'Watch and discuss WWDC Together',
            platforms: ['Web'],
            background: '#AAA5F0'
        }
    },
    {
        name: 'Where IP',
        slug: 'whereip',
        keywords: ['macos', 'menubar', 'tech', 'app', 'todo', 'swift', 'ip', 'public', 'monitor', 'ios', 'mac', 'reliable', 'location', 'country', 'city', 'coordinate', 'maps'],
        header: {
            background: '#94C072'
        },
        headline: {
            title: 'Where is your IP',
            text: 'Where IP is a native macOS application that monitors internet connection by checking public ip address and location, ensuring that you have control over your internet connection.',
            image: 'banner.png',
        },
        productHunt: {
            link: 'https://www.producthunt.com/posts/where-ip',
            id: '192656'
        },
        download: {
            appstore: [
                {
                    platform: "macOS",
                    version: "10.15",
                    id: 'id1506929908' 
                },
                {
                    platform: "iOS",
                    version: "13",
                    id: 'id1506929908' 
                }
            ]
        },
        features: [
            {
                title: 'Conveniently',
                texts: [
                    'Conveniently accessible from your menu bar',
                    'Show detail connection information visually on a map',
                    'Stay on top of where your IP connection is from',
                ],
                image: 'location.png',
                titleIcon: 'map',
                shadow: true
            },
            {
                title: 'History',
                texts: [
                    'Show history of recent monitoring sessions',
                    'Information includes IP, ISP, location and time when the ip was detected.'
                ],
                image: 'history.png',
                titleIcon: 'history',
                shadow: true
            },
            {
                title: 'Available on iPhone and iPad',
                texts: [
                    'The app is also available for iOS on iPhone and iPad',
                    'Detetc IP frequently'
                ],
                image: 'phone.png',
                titleIcon: 'phone_iphone',
            },
        ],
        showcase: {
            platforms: ['iOS', 'macOS'],
            background: '#94C072',
            tagline: 'Monitor public internet connection',
            detail: true
        }
    },
    {
        name: 'Hacker Type',
        slug: 'hackertype',
        keywords: ['macos', 'menubar', 'tech', 'app', 'todo', 'swift', 'ip', 'public', 'monitor', 'ios', 'mac', 'reliable', 'location', 'country', 'city', 'coordinate', 'maps'],
        header: {
            background: '#A4C6C7'
        },
        headline: {
            title: 'Auto type code snippet in Xcode',
            text: 'Hacker Type is a fun but smarts source editor extension that allows us to auto type, like hacker type, into our editor tab console.',
            image: 'banner.png',
        },
        productHunt: {
            link: 'https://www.producthunt.com/posts/hacker-type',
            id: '193667'
        },
        download: {
            appstore: [
                {
                    platform: "macOS",
                    version: "10.15",
                    id: 'id1508116372' 
                }
            ]
        },
        features: [
            {
                title: 'Nail your Xcode demo',
                texts: [
                    'I have given lots of tech talks and find the need to paste or type code snippet in a smart and cool way.',
                    "What would be better than having the code snippet automatically typed in so we don't need to remember the concrete code syntax.",
                    "Enter Hacker Type."
                ],
                imageUrl: 'https://user-images.githubusercontent.com/2284279/81641263-e29c9b80-9420-11ea-9f7a-239791d62485.gif',
                titleIcon: 'format_paint'
            },
            {
                title: 'Create code snippets via Mac app',
                texts: [
                    "To use this, open the associated mac app, press plus to start adding code snippet",
                    "For each code snippet, there is a header and a text. The header is for generating MARK comment header, and the text is the code snippet itself.",
                    'You can also press up and down arrow icon button to change the order of the selected snippet.',
                ],
                image: 'mac.png',
                titleIcon: 'laptop_mac',
                shadow: true
            },
            {
                title: 'Various actions',
                texts: [
                    'In Xcode, the extension is available via Editor -> Hacker Type menu. There are many actions',
                    'Reload snippets: Re read all snippets that you have added via the mac app',
                    'Previous snippet: Select the previous snippet in case you have many snippets',
                    'Next snippet: Select the next snippet in case you have many snippets',
                    'Type: auto type code base on the selected snippet. By default the selected snippet is the first one in your snippet list',
                    'Restart type: move the caret position to the start of the currently selected snippet so you can type from the beginning'
                ],
                image: 'menu.png',
                titleIcon: 'local_pizza',
                shadow: true
            },
            {
                title: 'Shortcut key',
                texts: [
                    'For quick action, you can set shortcut to Hacker Type menu item to quickly execute it.',
                    'You can do that by openning Preferences and then go to Behavior to set shortcut key in Xcode'
                ],
                image: 'key.png',
                titleIcon: 'keyboard',
                shadow: true
            }
        ],
        showcase: {
            platforms: ['macOS', 'Extension'],
            tagline: 'Auto complete code snippet in Xcode',
            background: '#A4C6C7',
            detail: true
        }
    },
    {
        name: 'Foil',
        slug: 'foil',
        productHunt: {
            link: 'https://www.producthunt.com/posts/foil-keyboard-locker',
            id: '181661'
        },
        download: {
            appstore: [
                {
                    platform: "macOS",
                    version: "10.14",
                    id: 'id1495288414'
                }
            ]
        },
        showcase: {
            platforms: ['macOS'],
            background: '#DCD728',
            tagline: 'Scratch pad for hacker on the menu bar',
        }
    },
    {
        name: 'Hacker Pad',
        slug: 'hackerpad',
        productHunt: {
            link: 'https://www.producthunt.com/posts/hacker-pad',
            id: '159933'
        },
        download: {
            appstore: [
                {
                    platform: "macOS",
                    id: 'id1470872890',
                    version: "10.14"
                }
            ]
        },
        showcase: {
            platforms: ['macOS'],
            background: '#161E35',
            tagline: 'Scratch pad for hacker on the menu bar',
        }
    },
    {
        name: 'Key Fighter',
        slug: 'keyfighter',
        productHunt: {
            link: 'https://www.producthunt.com/posts/key-fighter',
            id: '171153'
        },
        download: {
            appstore: [
                {
                    platform: "macOS",
                    id: 'id1483031420',
                    version: "10.14" 
                }
            ]
        },
        showcase: {
            platforms: ['macOS'],
            background: '#E3693B',
            tagline: 'Easy to remember keyboard shortcut',
        }
    },
    {
        name: 'Dev News',
        slug: 'devnews',
        productHunt: {
            link: 'https://www.producthunt.com/posts/dev-news-for-watch',
            id: '174704'
        },
        download: {
            appstore: [
                {
                    platform: "watchOS",
                    id: 'id1483110988',
                    version: "6.0"
                }
            ]
        },
        showcase: {
            platforms: ['watchOS'],
            background: '#3377AB',
            tagline: 'Dev news from GitHub, Hacker News, Reddit',
        }
    },
    {
        name: 'Quick Math',
        slug: 'quickmath',
        productHunt: {
            link: 'https://www.producthunt.com/posts/quick-math-for-watch',
            id: '174706'
        },
        download: {
            appstore: [
                {
                    platform: "watchOS",
                    version: "6.0",
                    id: 'id1485794967' 
                }
            ]
        },
        showcase: {
            platforms: ['watchOS'],
            background: '#DBA36B',
            tagline: 'Quick math expression solver for watch',
        }
    },
    {
        name: 'Address Generator',
        slug: 'addressgenerator',
        productHunt: {
            link: 'https://www.producthunt.com/posts/quick-math-for-watch',
            id: '117193'
        },
        download: {
            appstore: [
                {
                    platform: "macOS",
                    version: "10.13",
                    id: 'id1475068107'
                }
            ]
        },
        showcase: {
            platforms: ['macOS'],
            background: '#59AAF7',
            tagline: 'Generate crypto currency wallet and public address',
        }
    },
    {
        name: 'Ease',
        slug: 'ease',
        download: {
            appstore: [
                {
                    platform: "iOS",
                    id: 'id1047250647',
                    version: "9.0"
                }
            ]
        },
        showcase: {
            platforms: ['iOS'],
            background: '#5EA6AD',
            tagline: 'Gentle music for relax and sleep',
        }
    },
    {
        name: 'Xkcd',
        slug: 'xkcd',
        download: {
            appstore: [
                {
                    platform: "watchOS",
                    version: "6.0",
                    id: 'id1494057691'
                }
            ]
        },
        showcase: {
            platforms: ['watchOS'],
            background: '#F09896',
            tagline: 'Xkcd reader for watch',
        }
    },
    {
        name: 'Countries',
        slug: 'countries',
        download: {
            appstore: [
                {
                    platform: "watchOS",
                    version: "6.0",
                    id: 'id1488996986'
                }
            ]
        },
        showcase: {
            platforms: ['watchOS'],
            background: '#D1E4F5',
            tagline: 'Countries cyclopedia for the watch',
        }
    }
]

export default all